import { __rest } from "tslib";
import React from 'react';
import { default as getVariationsFromProps } from "@pb/utils/common/getVariationsFromProps";
import cn from 'classnames';
import Markup from "../../../../helpers/Markup";
import styles from './EditorialParagraph.module.scss';
const EditorialParagraph = (_a) => {
    var { Tag = 'p', className, children, content, lineClamp } = _a, props = __rest(_a, ["Tag", "className", "children", "content", "lineClamp"]);
    const [variationsClassNames, restOfProps] = getVariationsFromProps(Object.assign(Object.assign({}, props), (!!lineClamp && { [`lineClamp${lineClamp}`]: true })), styles);
    const classNames = cn(styles.general, className, variationsClassNames);
    if (typeof content === 'string') {
        return React.createElement(Markup, Object.assign({ input: content, Tag: Tag, className: classNames }, restOfProps));
    }
    return (React.createElement(Tag, Object.assign({ className: classNames }, restOfProps), children || content));
};
export default EditorialParagraph;
//# sourceMappingURL=EditorialParagraph.js.map